"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppointmentWaitlistLoadingMachine = exports.getInitialContext = void 0;
const xstate_1 = require("xstate");
const States_1 = require("../../../lib/constants/States");
const actions_loadingMachine_1 = __importStar(require("./actions.loadingMachine"));
const guards_loadingMachine_1 = __importStar(require("./guards.loadingMachine"));
const services_loadingMachine_1 = __importStar(require("./services.loadingMachine"));
/**
 * Initial context for the loading machine
 */
const getInitialContext = () => ({
    appointmentWaitlistId: '',
    waitlist: undefined,
    provider: undefined,
    services: {
        getWaitlistDetails: () => Promise.resolve({}),
        getProvider: () => Promise.resolve({})
    }
});
exports.getInitialContext = getInitialContext;
/**
 * Creates a machine to handle loading states for AppointmentWaitlist
 * @description This machine should be used as a sub machine
 */
const createAppointmentWaitlistLoadingMachine = (initialContext = (0, exports.getInitialContext)()) => (0, xstate_1.createMachine)({
    id: 'appointmentWaitlistLoaderMachine',
    initial: States_1.states.routing,
    context: initialContext,
    states: {
        [States_1.states.routing]: {
            always: [
                {
                    cond: guards_loadingMachine_1.isWaitlistDataNotFetched,
                    target: States_1.states.fetchWaitlist
                },
                {
                    cond: guards_loadingMachine_1.isProviderNotFetched,
                    target: States_1.states.fetchProvider
                },
                {
                    target: States_1.states.done
                }
            ]
        },
        [States_1.states.fetchWaitlist]: {
            invoke: {
                id: 'getAppointmentWaitlist',
                src: services_loadingMachine_1.getAppointmentWaitlist,
                onDone: {
                    target: States_1.states.fetchProvider,
                    actions: actions_loadingMachine_1.setWaitlist
                },
                onError: {
                    target: States_1.states.error
                }
            }
        },
        [States_1.states.fetchProvider]: {
            invoke: {
                id: 'getProvider',
                src: services_loadingMachine_1.getProvider,
                onDone: {
                    target: States_1.states.done,
                    actions: actions_loadingMachine_1.setProvider
                },
                onError: {
                    target: States_1.states.error
                }
            }
        },
        [States_1.states.done]: {
            entry: [actions_loadingMachine_1.sendParentDone]
        },
        [States_1.states.error]: {
            entry: [actions_loadingMachine_1.sendParentError]
        }
    }
}, {
    actions: actions_loadingMachine_1.default,
    guards: guards_loadingMachine_1.default,
    services: services_loadingMachine_1.default
});
exports.createAppointmentWaitlistLoadingMachine = createAppointmentWaitlistLoadingMachine;
//# sourceMappingURL=loadingMachine.js.map